module.exports = __webpack_public_path__ + "static/media/dueller.d0499040.png";